var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnWeb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.784 15.586a10.996 10.996 0 0 1-1.037 1.933c-.545.807-.992 1.365-1.336 1.674-.533.509-1.105.77-1.717.784-.44 0-.97-.13-1.586-.392-.62-.262-1.188-.392-1.708-.392-.545 0-1.13.13-1.756.392-.626.263-1.131.4-1.517.413-.587.026-1.172-.242-1.756-.805-.373-.337-.84-.914-1.398-1.733-.599-.874-1.092-1.888-1.477-3.043-.414-1.248-.621-2.457-.621-3.627 0-1.34.28-2.496.839-3.465A5.018 5.018 0 0 1 4.47 5.483a4.602 4.602 0 0 1 2.375-.695c.467 0 1.078.15 1.838.443.757.295 1.244.444 1.457.444.16 0 .7-.175 1.616-.523.866-.323 1.598-.457 2.197-.404 1.623.135 2.842.799 3.653 1.994-1.452.912-2.17 2.189-2.155 3.827.013 1.276.46 2.338 1.337 3.181.398.392.842.694 1.336.909-.107.322-.22.63-.34.927zM14.062.4c0 1-.353 1.934-1.055 2.799-.848 1.027-1.874 1.621-2.986 1.527A3.22 3.22 0 0 1 10 4.347c0-.96.403-1.987 1.12-2.828.357-.425.811-.779 1.363-1.061.55-.278 1.07-.432 1.56-.458.014.134.02.267.02.4z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWeb2);
export default __webpack_public_path__ + "static/media/icn_web_2.d5b97f3a28ee90695c018e158c92484d.svg";
export { ForwardRef as ReactComponent };